import { render, staticRenderFns } from "./Collect.vue?vue&type=template&id=cb242dd6"
import script from "./Collect.vue?vue&type=script&lang=js"
export * from "./Collect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports